import { DataContext } from 'App';
import { FC, ReactNode } from 'react';
import { Home } from 'components';

export const HomeContainer: FC = () => (
	<DataContext.Consumer>{(dataContext): ReactNode => <Home {...dataContext.pages.home} />}</DataContext.Consumer>
);
